import axios from 'axios';

const RESSOURCE_NAME = 'commandes';

export default {

    getRetards(idUser, column = "date_livraison_demandee", order = "DESC", page = 0, query = "") {
        return axios.get(
            `${RESSOURCE_NAME}/retards` + (idUser ? '/' + idUser : ''),
            { params: { page, size: process.env.VUE_APP_NB_DISPLAY, orderBy: column, sortBy: order, query } },
        );
    }

}